// extracted by mini-css-extract-plugin
export default {"content":"Style_content__xni7Q","frame":"Style_frame__5u2wm","footer":"Style_footer__ulC+7"};